<template>
  <div
    class="flex w-full flex-col justify-around gap-4 lg:flex-row lg:gap-8 lg:px-8"
  >
    <InputButton class="text-lg font-bold" block style-type="primary">
      View {{ coversCount }} more {{ industry }} agencies within 30 miles.
    </InputButton>
    <InputButton class="text-lg font-bold" block style-type="primary">
      View {{ nationalCount }} more {{ industry }} agencies within 100 miles.
    </InputButton>
  </div>
</template>

<script>
import InputButton from 'Components/InputButton.vue';

// How to server side render the covers and national counts
// Create QuickSearchService in Laravel
// Takes generic Search Parameters object and returns the counts for how many agencies are available in the other search, and a URL to each search.

export default {
  name: 'QuickSearch',
  components: { InputButton },
  props: {
    industry: {
      type: String,
      default: '',
    },
    nationalCount: {
      type: Number,
      default: 0,
    },
    nationalQuery: {
      type: String,
      default: '',
    },
    coversCount: {
      type: Number,
      default: 0,
    },
    coversQuery: {
      type: String,
      default: '',
    },
  },
};
</script>
